import { DialogStoreState } from '@app/store/client-slices/dialog/dialog-store-state';
import { KeyValuepair } from '@app/components/shared/model/key-valuepair';

export interface IDialogResult {
  confirmationMessage?: ConfirmationMessage;
  dialogStoreState?: DialogStoreState;
  button: Buttons | string;
  input?: string;
  inputMap?: Map<string, string>;
}


export enum Buttons {
  stang = 'Stäng',
  fortsatt = 'Fortsätt',
  avbryt = 'Avbryt',
  taBort = 'Ta bort',
  ctrlS = 'CtrlS',
}

export class ConfirmationMessage {
  title?: string;
  message?: string;
  primaryButton: Buttons | string;
  secondaryButton?: Buttons | string;
  bulletList?: Array<string>;
  messageLista?: Array<string>;
  correlationId?: string;
  useInput?: boolean;
  inputs?: Input[];
  customActionButton?: string;
  customActionCallback?: () => void;
}

export class Input {
  label?: string;
  hint?: string;
  keyValuepair?: KeyValuepair<string, string>;
  autocomplete?: string;
  name?: string;
  inputType?: string;
}
